import { api } from '@/api'

export interface OrdersQueryParams {
  'filter[status]'?: string
  'filter[payment_status]'?: string
  'filter[search]'?: string
  sort?: string
  page?: number
}

export interface OrderUser {
  id: string
  code: string
  full_name: string
  email: string
  mobile: string
}

export interface OrderCategory {
  name: string
}

export interface OrderProvider {
  name: string
}

export interface OrderService {
  id: string
  name: string
  slug: string
  logo_url: string | null
  category?: OrderCategory
  categories?: OrderCategory[]
  provider?: OrderProvider
}

export interface OrderCurrency {
  id: string
  code: string
  symbol: string
}

export interface OrderRegion {
  id: string
  name: string
}

export interface OrderPrice {
  id: string
  amount: string
  pricing_type: string
  unit: string | null
  billing_period: string
  currency?: OrderCurrency
  region?: OrderRegion
}

export interface OrderServicePlan {
  id: string
  name: string
  duration_days: number | null
  service?: OrderService
  price?: OrderPrice
}

export interface OrderItem {
  id: string
  name: string
  quantity: number
  unit_price: string
  total_amount: string
  service_plan?: OrderServicePlan
}

export interface AssignedAdmin {
  id: number
  name: string
}

export interface OrderDiscount {
  id: string
  code: string
}

export interface CustomServiceRequest {
  id: string
  service_name: string
  service_url: string | null
  payment_url: string | null
  amount: string
  description: string | null
  status: string
  currency?: {
    id: string
    title: string
    iso_code: string
  } | null
  country?: {
    id: string
    title: string
    country_code: string
  } | null
  attachment?: unknown
  created_at: string
  updated_at: string
}

export interface Order {
  id: string
  order_number: number
  subtotal_amount?: string
  fee_amount?: string
  total_amount: string
  discount_amount?: string
  shipping_amount?: string
  tax_amount: string
  final_amount: string
  status: string
  payment_status: string
  notes: string | null
  exchange_rate?: string | null
  currency_code?: string | null
  fee_percentage?: string | null
  vat_percentage?: string | null
  created_at: string
  updated_at: string

  user: OrderUser | null
  assigned_admin: AssignedAdmin | null
  discount?: OrderDiscount | null
  items: OrderItem[] | null
  custom_service_request?: CustomServiceRequest | null
}

export interface OrdersResponse {
  data: Order[]
  pagination?: {
    total?: number
    perPage?: number
  }
}

export interface OrderDetailResponse {
  data: Order
}

export type UpdateOrderStatusPayload = Record<string, unknown> & {
  status: string
}

export interface UpdateOrderStatusResponse {
  data: Order
}

export const getOrdersAction = (params: OrdersQueryParams) =>
  api.v2.get('/orders', { params }) as Promise<OrdersResponse>

export const getOrderAction = (uuid: string) => api.v2.get(`/orders/${uuid}`) as Promise<OrderDetailResponse>

export const updateOrderStatusAction = (id: string, payload: UpdateOrderStatusPayload) =>
  api.v2.patch(`/orders/${id}/status`, payload) as Promise<UpdateOrderStatusResponse>
